import PageWithNavbar from './PageWithNavbar';

const sidebarStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  width: 240,
  background: '#f8fafc',
  borderRight: '1px solid #e5e7eb',
  padding: '96px 16px 32px 16px', // Add top padding for navbar height
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
};

const headingStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 400,
  marginBottom: 2,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
};

const linkStyle: React.CSSProperties = {
  display: 'block',
  color: '#2563eb',
  textDecoration: 'none',
  fontSize: 16,
  marginBottom: 12,
  fontWeight: 500,
  padding: '4px 0',
};

export default function ManageLayout({ children }: { children: React.ReactNode }) {
  return (
    <PageWithNavbar>
      <div style={{ display: 'flex' }}>
        <aside style={sidebarStyle}>
          <div style={headingStyle}>Friends & Family</div>
          <nav>
            <a href="#" style={linkStyle}>Addresses</a>
            <a href="#" style={linkStyle}>People</a>
          </nav>
        </aside>
        <main style={{ flex: 1, marginLeft: 240, minHeight: '100vh', background: '#f8fafc' }}>
          {children}
        </main>
      </div>
    </PageWithNavbar>
  );
}
